/**
 * Returns true if the end of the string matches the search string
 */
function is99StaffEmail(email: string) {
    const search = '@99designs.com';
    return email.substr(-search.length) === search;
}

export default is99StaffEmail;
